module.exports = __webpack_public_path__ + "static/media/financepic4.d9502d4f.png";